export default {
    state: {
        filledTrackerCol: ['', '', '', '', '', '', ''],
        activeCol: 0
    },
    getters: {
        getFillerCol(state) {
            return state.filledTrackerCol
        },
        getActiveCol(state) {
            return state.activeCol
        }
    },
    mutations: {
        setNewTrackerCol(state, payload) {
            const {idx, content} = payload;
            state.filledTrackerCol[idx] = content;
        },
        setActiveCol(state, payload) {
            state.activeCol = payload
        },
        clearFilledTracker(state) {
            state.filledTrackerCol = ['', '', '', '', '', '', ''];
        }
    },
    actions: {
        async saveNewTrackerCol(context, payload) {
            let {oldData, content, col} = payload;
            oldData.tracker[col.table][col.col] = content;
            if (col.col === 5) oldData.tracker.push([])
            await context.dispatch('changeUserData', {newData: oldData, id: oldData.id})
        }
    },
}